import { render, staticRenderFns } from "./editCategory.vue?vue&type=template&id=1a44fb59&scoped=true"
import script from "./editCategory.vue?vue&type=script&lang=js"
export * from "./editCategory.vue?vue&type=script&lang=js"
import style0 from "./editCategory.vue?vue&type=style&index=0&id=1a44fb59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a44fb59",
  null
  
)

export default component.exports